export default __webpack_public_path__ + "static/media/check.d48ead04.svg";